import React from "react";
import PropTypes from "prop-types";
import { Table } from "antd";

// The virtual list scrolls in JS (no native momentum on touch, trackpad swipes
// past its edge reach the browser), so it's only used where rendering every
// row would be slow. A `virtual` prop still overrides it.
const VIRTUAL_MIN_ROWS = 200;

const AntTable = (props) => (
  <Table
    scroll={{
      x: 2000,
      y: 400,
    }}
    virtual={(props.dataSource?.length || 0) > VIRTUAL_MIN_ROWS}
    pagination={false}
    sortOrder="descend"
    size="middle"
    {...props}
  />
);

AntTable.propTypes = {
  data: PropTypes.array,
  dataSource: PropTypes.array,
  columns: PropTypes.array,
  className: PropTypes.string,
  rowKey: PropTypes.string.isRequired,
};

export default AntTable;
